import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { PaymentMethodLookUp } from "./payment.lookup";

export class ReceiptPaymentModel extends EntityBase {
  Index: number;
  Amount: number;
  TransactionNumber: string;
  PaymentMethod?: PaymentMethodLookUp[];
  PaymentMethodId: number;
  PaymentMethodTitle: string;
  ReceiptPaymentType?: Lookup[];
  ReceiptPaymentTypeCode?: number;
  ReceiptPaymentTypeId?: number;
  ReceiptPaymentTypeTitle: string;
  BranchId: number;
  CustomerId?: number;
  SettlementId: number;
  InvoiceId: number;
  ShowPospayment: boolean;
  CustomerTitle: string;
  CustomerCode: number;
  IsRemain: boolean;
  PaymentMethodCode?: number;
  posPaymentIndex: number;
  DebitTotal?: number;
  RowVersion: any;
  NonBalance: boolean;
  Comment: string;
  UntilDateClear: Date;
  hasTerminal: boolean;
  constructor() {
    super();
    this.Amount = 0;
    this.Comment = "";
    this.RowVersion = null;
    this.UntilDateClear = null;
    this.Index = 0;
    this.ShowPospayment = false;
    this.TransactionNumber = "";
    this.PaymentMethod = null;
    this.PaymentMethodId = null;
    this.ReceiptPaymentType = null;
    this.ReceiptPaymentTypeId = null;
    this.ReceiptPaymentTypeTitle = null;
    this.BranchId = null;
    this.CustomerId = null;
    this.SettlementId = null;
    this.InvoiceId = null;
    this.CustomerTitle = "";
    this.ShowPospayment = null;
    this.CustomerCode = null;
    this.IsRemain = false;
    this.DebitTotal = 0;
    this.NonBalance = false;
  }
}
export enum ReceiptPaymentTypeEnum {
  Payment = 1,
  Receipt = 2,
}
